import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {FaIcon} from "../FaIcon";

export class ExecuteSyncConfigurationButton extends Component {
    constructor(props) {
        super(props);

        this.handleExecute = this.handleExecute.bind(this);
    }

    handleExecute () {
        if(this.props.isBeingSyncedRightNow === true)
            return;

        new APIClient(API_URL + `node-to-gsheet/sync-configuration/${this.props.syncConfigurationId}/execute`).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.props.onExecuteSyncConfiguration(this.props.syncConfigurationId);
        })
    }

    renderTitle() {
        if (this.props.isBeingSyncedRightNow) {
            return "Actualizando los datos. Este proceso puede tardar unos minutos.";
        }

        return "Actualizar datos en planilla";
    }

    render() {
        return <button onClick={this.handleExecute} className='pe-1' title={this.renderTitle()}>
            <FaIcon type="button" iconName="sync-alt" spin={this.props.isBeingSyncedRightNow}/>
        </button>
    }
}

